module.exports = __webpack_public_path__ + "img/5.726c6d74.svg";